import React from 'react';
import logo from './logo.svg';
import './App.css';
import UploadImage from './uploadImage';

function App() {
  return (
    <UploadImage />
  );
}

export default App;
